import { useContext } from 'react';

import { AppContext } from 'context/AppContext';

export default function useOnline() {
  const { isOnline } = useContext(AppContext);
  return isOnline;
}
